export async function afterSignUp() {}
